import { useEffect } from 'react';

function Header() {

  useEffect(() => {
    const sections = document.querySelectorAll("span")
    const navLi = document.querySelectorAll(".nav_link")
  
    window.onscroll = () => {
        var current = "";
        
        sections.forEach((section) => {
            const y = window.scrollY;
            const sectionTop = section.offsetTop;

            if (y >= sectionTop - 137 ) {
            current = section.getAttribute("id");
            }
        });
        
        navLi.forEach((a) => {
            a.classList.remove("active");
            if (a.classList.contains(current)) {
            a.classList.add("active");
            }
        });
    };
  }, []);
      
    return (
        <div className='header_wrapper'>
            <p className='title_header' >Développeur Web Front</p>
            <section className='nav_wrapper'>
                <nav className='navbar'>
                    <a className='about nav_link active' href="#about">
                        À propos
                    </a>
                    <a className='projets nav_link' href='#projets'>
                        Projets
                    </a>
                    <a className='skills nav_link' href="#skills">
                        Compétences
                    </a>
                </nav>
            </section>
        </div>
    )
}

export default Header